// File: client/src/variants/classic/rulebook.js
// Canonical rulebook for Classic Chess.

const rulebook = {
  overview:
    'Standard international chess — the same rules used in tournaments worldwide. No cards, no modifiers, no special mechanics.',
  objective:
    'Checkmate your opponent’s king: attack it so that it cannot escape capture on the next move.',
  setup:
    'The standard starting position: each side has 8 pawns, 2 rooks, 2 knights, 2 bishops, a queen, and a king. White moves first.',
  turnFlow: [
    'On your turn, make exactly one legal move.',
    'A move must not leave your own king in check.',
    'Play then passes to your opponent.',
  ],
  mechanics: [
    {
      title: 'Piece movement',
      items: [
        'Pawn: forward one square (or two from its start); captures diagonally.',
        'Knight: an L-shape; the only piece that leaps over others.',
        'Bishop: any distance diagonally.',
        'Rook: any distance horizontally or vertically.',
        'Queen: any distance in any straight line.',
        'King: one square in any direction.',
      ],
    },
    {
      title: 'Special moves',
      items: [
        'Castling: king and rook move together if neither has moved, the path is clear, and the king does not pass through or land in check.',
        'En passant: a pawn may capture an adjacent pawn that just advanced two squares.',
        'Promotion: a pawn reaching the far rank becomes a queen, rook, bishop, or knight.',
      ],
    },
  ],
  winConditions: [
    'Win by checkmating the opponent’s king.',
    'Win if the opponent resigns or runs out of time.',
    'Draw by stalemate (no legal move while not in check).',
  ],
  tips: [
    'Control the centre early.',
    'Develop your knights and bishops before your queen.',
    'Castle early to protect your king.',
  ],
  knownInteractions: [
    'This mode is unmodified standard chess and is unaffected by any variant systems.',
  ],
};

export default rulebook;
